module.exports = __webpack_public_path__ + "img/tose-taavon.95ae24b5.svg";